module.exports = __webpack_public_path__ + "img/key.cb868614.svg";